/* tslint:disable */
/* eslint-disable */
/**
 * HCL Commerce Services - Account and Contract
 * These services provide APIs to manage accounts and contracts.  a contract is an agreement that represents the terms and conditions that apply to a transaction. An account is a relationship between the merchant and the financial institution that processes transactions for that merchant.
 *
 * The version of the OpenAPI document: 9.1.6
 * 
 * (C) Copyright HCL Technologies Limited 2021
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../../../../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../../../../base';
// @ts-ignore
import { ContactUsRequest } from '../../../../../com/hcl/commerce/typescript/axios';
// @ts-ignore
import { ContactUsResponse } from '../../../../../com/hcl/commerce/typescript/axios';
/**
 * ContactUsApi - axios parameter creator
 * @export
 */
export const ContactUsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Submit the users contact details.
         * @summary Submit the users contact details
         * @param {string} storeId The store identifier.
         * @param {ContactUsRequest} contactUsRequest The request object for project creation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactUs: async (storeId: string, contactUsRequest: ContactUsRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('contactUs', 'storeId', storeId)
            // verify required parameter 'contactUsRequest' is not null or undefined
            assertParamExists('contactUs', 'contactUsRequest', contactUsRequest)
            const localVarPath = `/store/{storeId}/resources/contact/contactus`
                .replace(`{${"storeId"}}`, String(storeId));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(contactUsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContactUsApi - functional programming interface
 * @export
 */
export const ContactUsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContactUsApiAxiosParamCreator(configuration)
    return {
        /**
         * Submit the users contact details.
         * @summary Submit the users contact details
         * @param {string} storeId The store identifier.
         * @param {ContactUsRequest} contactUsRequest The request object for project creation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async contactUs(storeId: string, contactUsRequest: ContactUsRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContactUsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.contactUs(storeId, contactUsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ContactUsApi - factory interface
 * @export
 */
export const ContactUsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContactUsApiFp(configuration)
    return {
        /**
         * Submit the users contact details.
         * @summary Submit the users contact details
         * @param {string} storeId The store identifier.
         * @param {ContactUsRequest} contactUsRequest The request object for project creation.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contactUs(storeId: string, contactUsRequest: ContactUsRequest, options?: any): AxiosPromise<ContactUsResponse> {
            return localVarFp.contactUs(storeId, contactUsRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContactUsApi - object-oriented interface
 * @export
 * @class ContactUsApi
 * @extends {BaseAPI}
 */
export class ContactUsApi extends BaseAPI {
    /**
     * Submit the users contact details.
     * @summary Submit the users contact details
     * @param {string} storeId The store identifier.
     * @param {ContactUsRequest} contactUsRequest The request object for project creation.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactUsApi
     */
    public contactUs(storeId: string, contactUsRequest: ContactUsRequest, options?: any) {
        return ContactUsApiFp(this.configuration).contactUs(storeId, contactUsRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
